import Sidebar from "~/components/Sidebar/Sidebar";
import type { Location, UserAvailableLocationType } from "~/modules/location/api/location/locationTypes.ts";
import type { UsersActiveStaffingsQuotas, UsersActiveStaffingType } from "~/modules/project/api/staffing/staffingTypes.ts";
import type { UserAvailableDeliverableType } from "~/modules/timeTracking/api/deliverable/deliverableTypes.ts";
import type { TimeTrackingType } from "~/modules/timeTracking/api/timeTrackingType/timeTrackingTypeTypes.ts";
import { CreateTimeTrackingPanel } from "~/modules/timeTracking/components/CreateTimeTrackingPanel";
import type { User } from "~/modules/user/api/user/userTypes.ts";

type CreateTimeTrackingSidebarProps = {
	activeStaffings: UsersActiveStaffingType[];
	nonProjectIsClosed: boolean;
	userDeliverables: UserAvailableDeliverableType[];
	userLocations: UserAvailableLocationType[];
	close: () => void;
	trackedStaffingIds: string[];
	isOpen: boolean;
	date: null | Date,
	locations: Location[];
	quotas: UsersActiveStaffingsQuotas;
	selectedUserId: User["id"];
	timeTrackingTypes: TimeTrackingType[];
	users: User[];
	userIsFreelancer: boolean
};

export default function CreateTimeTrackingSidebar({
	close,
	isOpen,
	...panelProps
}: CreateTimeTrackingSidebarProps) {
	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={close}>
			<CreateTimeTrackingPanel {...panelProps}
									 onClose={close}
									 parentIsVisible={isOpen} />
		</Sidebar>
	);
}
